import React, { useState, useEffect } from 'react';
import PageLayout from '../Components/PageLayout';
import './Faqpage.css';

const generalFaqs = [
  {
    question: 'What is CoinBazaar Digital powered by eBullion?',
    answer: (
      <div>
        CoinBazaar Digital and eBullion have collaborated to offer an investment platform that provides 24/7 access to buy, sell, and gift precious metals online like Gold, Platinum, Palladium, and Silver on the go.
      </div>
    ),
  },
  {
    question: 'Why choose to invest in digital precious metals through CoinBazaar Digital?',
    answer: (
      <div>
        <p>
          CoinBazaar Digital powered by eBullion Pvt Ltd is an investment platform that enables an individual to invest in key precious metals. This revolutionary platform offers an unparalleled opportunity to buy, sell, gift and invest in SIP in four precious metals (Gold, Silver, Platinum, and Palladium), with a minimal investment of just Rs. 100, at international spot prices fetched real-time from globally trusted data providers.
        </p>
        <p>
          eBullion assures your investment is backed by physical metal which is kept in a top-of-the-line secured and insured SEBI-regulated vault. A distinctive feature of eBullion is its self-regulated model where a customer's precious metal and funds are secured, with customer funds held in an escrow bank account.
        </p>
        <p>
          eBullion is powered by Hindustan Platinum Pvt Ltd., which has 60+ years of experience in refining precious metals, accredited by LBMA and LLPM for Good Delivery.
        </p>
        <p>We at eBullion assure you that your investment is in safe hands and grows with each passing day.</p>
      </div>
    ),
  },
  {
    question: 'Can minors buy digital metal online?',
    answer: <div>Any individual below the age of 18 is not eligible to buy or sell precious metals online.</div>,
  },
  {
    question: 'What are the eligibility criteria for registering?',
    answer: <div>Any Indian citizen with a bank account, a valid PAN and an Indian mobile number is eligible to enroll with CoinBazaar Digital.</div>,
  },
  {
    question: 'Is it mandatory to upload my PAN card?',
    answer: <div>No, PAN is not mandatory for signup and purchase of any metal consolidated up to ₹1000.</div>,
  },
  {
    question: 'What is the minimum & maximum amount needed to buy metals on CoinBazaar Digital powered eBullion?',
    answer: (
      <div>
        The minimum amount of purchase is ₹100. There is no limit on the maximum amount as long as KYC requirements are complied with. The SIP plan can be initiated with a minimum investment of ₹100 while accommodating a maximum investment limit of ₹99,999 with an option to invest in either weekly or monthly intervals.
      </div>
    ),
  },
  {
    question: 'What is the purity of the precious metals offered to customers?',
    answer: (
      <div>
        <p>eBullion sources precious metals from London Good Delivery Refiners only. The purity of the precious metal is as follows:</p>
        <table className="faq-table">
          <thead>
            <tr>
              <th>Metal</th>
              <th>Purity</th>
              <th>Metal</th>
              <th>Purity</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Gold</td>
              <td>99.99%</td>
              <td>Platinum</td>
              <td>99.95%</td>
            </tr>
            <tr>
              <td>Silver</td>
              <td>99.99%</td>
              <td>Palladium</td>
              <td>99.95%</td>
            </tr>
          </tbody>
        </table>
      </div>
    ),
  },
  {
    question: 'Do you charge for the storage of my metal?',
    answer: (
      <div>
        We offer free storage for up to 3 years, after which we reserve the right to charge a yearly nominal fee of approximately 0.3–0.4% (per annum) of your metal balance.
      </div>
    ),
  },
  {
    question: 'What certification does eBullion have on physical precious metals?',
    answer: (
      <div>
        eBullion procures all physical metal from Hindustan Platinum, which has been refining Silver, Platinum, and Palladium for 60+ years. Hindustan Platinum is listed on both LPPM's Good Delivery List for Platinum and Palladium and LBMA's Good Delivery List for Silver.
      </div>
    ),
  },
  {
    question: 'Where is the physical metal stored?',
    answer: (
      <div>
        We have partnered with Sequel Logistics, one of the world's largest security companies. Sequel's High-Grade Vaults are certified by SEBI & LBMA for precious metals storage. All metal stored is insured and secured.
      </div>
    ),
  },
  {
    question: 'Can I add a bank account with a different name than my PAN card?',
    answer: <div>Please use the same name as on your PAN card, as this will aid with the verification of your bank information.</div>,
  },
  {
    question: 'Why is KYC needed?',
    answer: (
      <div>
        Safeguarding your precious metals is our top priority. KYC assures that your transactions are safer and helps prevent account abuse and illegal access to your funds.
      </div>
    ),
  },
  {
    question: 'What payment modes are accepted?',
    answer: (
      <div>
        Customers can make payments through net banking, UPI, and the CoinBazaar Digital wallet via Virtual Account facility.
      </div>
    ),
  },
  {
    question: 'Where do I see my transactions?',
    answer: <div>Your transactions are available at all times. Click on the Transaction History tab to view them online.</div>,
  },
  {
    question: 'How much time does it take to get the money transferred to my bank after selling my Digital Gold?',
    answer: (
      <div>
        <p>Once the metal is sold, the money will be credited to your bank account within 24 hours.</p>
        <p className="faq-contact">
          We are just a call away — feel free to contact us at <strong>+91-8169860012</strong> or write to us at{' '}
          <a href="mailto:info@coinbazaar.in">info@coinbazaar.in</a>
        </p>
      </div>
    ),
  },
];

const sipFaqs = [
  {
    question: 'What is SIP in CoinBazaar Digital?',
    answer: (
      <div>
        Systematic Investment Plan (SIP) is a scheme where you can invest in Gold, Silver, Platinum, and Palladium for a fixed amount at a fixed selected interval (Weekly/Monthly).
      </div>
    ),
  },
  {
    question: 'Why should one choose the SIP scheme by CoinBazaar Digital?',
    answer: (
      <div>
        It enables you to accumulate Gold, Silver, Platinum, and Palladium in smaller quantities through periodic installments, leveraging the price benefit.
      </div>
    ),
  },
  {
    question: 'What price is considered at the time of installment deduction of SIP?',
    answer: (
      <div>
        The periodic installment is used on your selected date to buy precious metals at the price prevailing at the time of fund deduction.
      </div>
    ),
  },
  {
    question: 'Can you choose multiple SIPs?',
    answer: <div>Yes, you can choose to invest in multiple metals with different amounts simultaneously.</div>,
  },
  {
    question: 'What is the minimum amount of investment for SIP?',
    answer: (
      <div>
        SIP investment can be started at just ₹100 a week or every month. The maximum SIP installment amount is ₹99,999.
      </div>
    ),
  },
  {
    question: 'What will happen if my bank account has insufficient funds when my SIP payment is due?',
    answer: (
      <div>
        We will attempt the transaction again the next day. If it fails again, the SIP payment for that specific week or month is missed after two unsuccessful attempts. We do not charge any late fee or unsuccessful attempt fee.
      </div>
    ),
  },
  {
    question: 'Can the tenure of the SIP plan be extended?',
    answer: (
      <div>
        No, once a SIP plan has been successfully created, its tenure cannot be extended. However, you can create a new SIP plan with one click from your current SIP or after expiry.
      </div>
    ),
  },
  {
    question: 'Where can I find the invoice for each order?',
    answer: (
      <div>
        All transactions are displayed in your CoinBazaar Digital passbook. You can download the invoice from the Passbook section in the dashboard.
      </div>
    ),
  },
  {
    question: 'How soon can I start investing in SIP and when does my SIP start?',
    answer: (
      <div>
        <p>
          You can start investing in SIP right away. You can choose the date of installment deduction starting from the 5th day from the date of SIP initiation.
        </p>
        <p className="faq-contact">
          We are just a call away — feel free to contact us at <strong>+91-8169860012</strong> or write to us at{' '}
          <a href="mailto:info@coinbazaar.in">info@coinbazaar.in</a>
        </p>
      </div>
    ),
  },
];

const giftFaqs = [
  {
    question: "What is CoinBazaar's precious metal gifting?",
    answer: (
      <div>
        Precious metals can now be gifted to your loved ones. You can effortlessly gift Gold, Silver, Platinum, and Palladium digitally with our Precious Metal Gifting feature, transforming memorable occasions into enduring treasures.
      </div>
    ),
  },
  {
    question: 'How can I send digital precious metal as a gift?',
    answer: (
      <div>
        <p>Please follow the steps below to gift precious metal:</p>
        <ol className="faq-steps">
          <li><strong>Step 1:</strong> Select your preferred metal on the Gifting tab and enter the quantity in grams or rupees.</li>
          <li><strong>Step 2:</strong> Enter the recipient's name, phone number, and a personalized message.</li>
          <li><strong>Step 3:</strong> Click the Submit button.</li>
        </ol>
        <p>As soon as the gift is sent, both you and the recipient will receive a text confirmation.</p>
      </div>
    ),
  },
  {
    question: 'Is there a minimum amount for CoinBazaar Digital precious metal gifts?',
    answer: <div>The digital precious metal gifting feature allows you to gift precious metal for as low as ₹100.</div>,
  },
  {
    question: 'How does the recipient redeem their CoinBazaar Digital precious metal gift?',
    answer: (
      <div>
        Once a gift is sent, the recipient receives an SMS and can view it in the Received Gift section of the app. The receiver then needs to click the Accept Gift button in the Gift section.
      </div>
    ),
  },
  {
    question: 'Can the receiver reject the gift?',
    answer: <div>The recipient has the option to either accept or reject the gift within 15 days from the date of receipt.</div>,
  },
  {
    question: "What happens if the recipient doesn't have an account on CoinBazaar Digital?",
    answer: (
      <div>
        Once the gift is sent, the recipient will receive a link to sign up via the website. Once they create an account, they will be able to view it in the Received Gift section.
      </div>
    ),
  },
  {
    question: "How secure is CoinBazaar's Digital precious metal gifting?",
    answer: (
      <div>
        Every purchase made with digital precious metal gifting is safe and secure. Our payment partner guarantees secure transactions, while our vaulting partner ensures your precious metal is physically secured and insured.
      </div>
    ),
  },
  {
    question: "Can I personalize my CoinBazaar Digital gift?",
    answer: (
      <div>
        Yes! The personal message feature allows users to add a special touch to their digital gifts, making your gesture even more meaningful and personalized.
      </div>
    ),
  },
  {
    question: 'Is there an expiry date for CoinBazaar Digital precious metal gifts?',
    answer: (
      <div>
        <p>
          Yes, the CoinBazaar Digital precious metal gift is valid for 15 days after it is sent. If the gift is not actioned within that period, it will automatically be returned to the sender's metal balance.
        </p>
        <p className="faq-contact">
          We are just a call away — feel free to contact us at <strong>+91-8169860012</strong> or write to us at{' '}
          <a href="mailto:info@coinbazaar.in">info@coinbazaar.in</a>
        </p>
      </div>
    ),
  },
];

const CATEGORIES = [
  { key: 'general', label: 'General', faqs: generalFaqs },
  { key: 'sip', label: 'SIP', faqs: sipFaqs },
  { key: 'gift', label: 'Gift', faqs: giftFaqs },
];

const FaqPage = () => {
  const [activeCategory, setActiveCategory] = useState('general');
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setOpenIndex(null);
  }, [activeCategory]);

  const activeFaqs = CATEGORIES.find((c) => c.key === activeCategory)?.faqs || [];

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <PageLayout page="faqs">
      <div className="faq-page">
        <header className="faq-header">
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">Everything you need to know about CoinBazaar Digital</p>
          <div className="faq-title-bar" />
        </header>

        <section className="faq-category-tabs">
          {CATEGORIES.map((cat) => (
            <button
              key={cat.key}
              className={`faq-tab-btn${activeCategory === cat.key ? ' faq-tab-btn--active' : ''}`}
              onClick={() => setActiveCategory(cat.key)}
            >
              {cat.label}
            </button>
          ))}
        </section>

        <section className="faq-list">
          {activeFaqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item${openIndex === index ? ' faq-item--open' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => handleToggle(index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-question-text">{item.question}</span>
                <span className="faq-icon" aria-hidden="true">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </section>
      </div>
    </PageLayout>
  );
};

export default FaqPage;